module.exports = __webpack_public_path__ + "static/media/movieType-scifi.0839049f.jpg";